import { useSnackbar } from 'notistack';
import { Dispatch, useEffect, useRef, useState } from 'react';
import { createSiteProcess } from '../../../../apicalls/attendanceManages';
import { TSelectItem } from '../../../../types/common';
import { checkResData } from '../../../../utils/common';
import { UseFormReset } from 'react-hook-form';
import {
  CATEGORY_PARENT_SITE_PROCESS,
  CATEGORY_CHILD_SITE_PROCESS
} from '../../../../const/ProcessConst';
import {
  convertFormDateToApiDate,
  createSiteProcessAndSiteTaskEmployeeList
} from '../../../../utils';
import { TAddSiteProcessForm } from '../../../../types/attendancManage';
import { getVendorList } from '../../../../apicalls/getVendorDetails';
import { createGanttResourceAndEvent } from '../../../../utils/attendancePage';
import { useRecoilState } from 'recoil';
import {
  attendanceAssignTotallOfDate,
  attendanceGanttData
} from '../../../../GlobalState';

export type TProps = {
  setIsOpen: Dispatch<boolean>;
  constructId: number;
  reset: UseFormReset<any>;
  isOpen: boolean;
  setIsLoadingGantt: Dispatch<boolean>;
  parentSiteProcessId?: number;
  initialVisibleRange: any;
};

export const useHooks = (props: TProps) => {
  const {
    setIsOpen,
    constructId,
    reset,
    isOpen,
    setIsLoadingGantt,
    parentSiteProcessId,
    initialVisibleRange
  } = props;

  // 送信可能フラグ 多重送信対策
  const isSubmitable = useRef(false);
  const [, setInitialGanttData] = useRecoilState(attendanceGanttData);
  const [, setAssignTotallOfDate] = useRecoilState(
    attendanceAssignTotallOfDate
  );

  const submit = (form: TAddSiteProcessForm) => {
    if (!isSubmitable.current) return;

    isSubmitable.current = false;
    setIsLoadingGantt(true);

    createSiteProcess(
      constructId,
      form.business_type.value,
      convertFormDateToApiDate(form.start_date) as string,
      convertFormDateToApiDate(form.end_date) as string,
      form.user_id?.value ? form.user_id.value : 0,
      form.partner_id?.value ? form.partner_id.value : 0,
      form.artificial
    ).then((resData: any) => {
      checkResData(resData, enqueueSnackbar)
        .then(async (data: any) => {
          if (data) {
            setIsOpen(false);
            const { resources, events, attendanceManageEventList } =
              await createGanttResourceAndEvent(
                constructId,
                enqueueSnackbar,
                initialVisibleRange.start,
                initialVisibleRange.end
              );
            setAssignTotallOfDate(attendanceManageEventList);
            setInitialGanttData({
              resources,
              events
            });
          }
        })
        .finally(() => {
          isSubmitable.current = true;
          setIsLoadingGantt(false);
        });
    });
  };

  // radioボタンの設定
  const businessTypeList: TSelectItem[] = [
    { label: '--', value: 0 },
    { label: '自社', value: 1 },
    { label: '協力会社', value: 2 }
  ];

  // 担当者選択リスト
  const [employeeList, setEmployeeList] = useState<TSelectItem[]>([]);
  // 企業名選択リスト
  const [partnerList, setPartnerList] = useState<TSelectItem[]>([]);

  // キャンセル時の処理
  const cancelSubmit = () => {
    setIsOpen(false);
  };

  // 期間終了日付
  const [endDate, setEndDate] = useState('');

  // 期間終了日付変更時のハンドラ
  const handleChangeEndDatePicker = (e: any) => {
    setEndDate(e.target.value);
  };

  // snackbar
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (isOpen) {
      // 初期値セット
      setEndDate('');
      reset({
        category: parentSiteProcessId
          ? CATEGORY_CHILD_SITE_PROCESS
          : CATEGORY_PARENT_SITE_PROCESS,
        parent_site_process_id: { value: 0, label: '--' },
        site_process_name: null,
        construct_id: { value: 0, label: '--' },
        user_id: { value: 0, label: '--' },
        start_date: null,
        end_date: null,
        planned_man_day: null,
        note: null
      });
      // 担当者選択プルダウン
      createSiteProcessAndSiteTaskEmployeeList(
        constructId,
        enqueueSnackbar
      ).then(employeeList => {
        setEmployeeList(employeeList);
      });

      getVendorList().then(resData => {
        checkResData(resData, enqueueSnackbar).then((data: any) => {
          const dataList = data.data;
          const tmpList: TSelectItem[] = [{ value: 0, label: '--' }];
          if (dataList && dataList.length > 0) {
            dataList.map((item: any) => {
              tmpList.push({
                label: item.name,
                value: item.id
              });
            });
            setPartnerList(tmpList);
          }
        });
      });

      // オープン時に送信可能にする
      isSubmitable.current = true;
    }
  }, [isOpen]);

  return {
    submit,
    cancelSubmit,
    businessTypeList,
    employeeList,
    partnerList,
    endDate,
    handleChangeEndDatePicker
  };
};
